import { render } from "./LiquidationPage.vue?vue&type=template&id=667a7f70"
import script from "./LiquidationPage.vue?vue&type=script&lang=js"
export * from "./LiquidationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__